export enum DEVICE_SIZE {
  mobileS = '320px',
  mobileM = '375px',
  mobileL = '768px',
  tablet = '1024px',
  desktopM = '1440px',
  desktop = '1660px',
}

export const device = {
  mobileS: `(min-width: $DEVICE_SIZE.mobileS)`,
  mobileM: `(min-width: ${DEVICE_SIZE.mobileM})`,
  mobileL: `(min-width: ${DEVICE_SIZE.mobileL})`,
  tablet: `(min-width: ${DEVICE_SIZE.tablet})`,
  desktopM: `(min-width: ${DEVICE_SIZE.desktopM})`,
  desktop: `(min-width: ${DEVICE_SIZE.desktop})`,
}

export const browser = {
  ie11: `(-ms-high-contrast: none)`,
}

export enum GRID_BREAKPOINTS {
  desktop = '1280px',
  desktopSm = '1066px',
  mobile = '768px',
}
